var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30.9 33.1",
    style: {
      enableBackground: "new 0 0 30.9 33.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,23.3c-0.7,0-1.3,0.6-1.3,1.3v2.5c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3v-2.5C7.2,23.9,6.7,23.3,6,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7,23.3c-0.7,0-1.3,0.6-1.3,1.3v2.5c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3v-2.5C12,23.9,11.4,23.3,10.7,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,23.3c-0.7,0-1.3,0.6-1.3,1.3v2.5c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3v-2.5C16.8,23.9,16.2,23.3,15.5,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3,23.3c-0.7,0-1.3,0.6-1.3,1.3v2.5c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3v-2.5C21.5,23.9,20.9,23.3,20.3,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,28.3c0.7,0,1.3-0.6,1.3-1.3v-2.5c0-0.7-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3V27C23.8,27.8,24.3,28.3,25,28.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4,17.5c0-0.7-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3V20c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3V17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1,17.5c0-0.7-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3V20c0,0.7,0.6,1.3,1.3,1.3s1.3-0.6,1.3-1.3V17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1,14.2c0.7,0,1.3-0.6,1.3-1.3v-2.5c0-0.7-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3v2.5C11.9,13.7,12.4,14.2,13.1,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,14.2c0.7,0,1.3-0.6,1.3-1.3v-2.5c0-0.7-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3v2.5C16.6,13.7,17.2,14.2,17.9,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7,18.8h-5.9V5.9c0-0.7-0.6-1.3-1.3-1.3h-5.7V2.1c0-0.7-0.6-1.3-1.3-1.3s-1.3,0.6-1.3,1.3v2.5H8.5 c-0.7,0-1.3,0.6-1.3,1.3v12.9H1.3c-0.7,0-1.3,0.6-1.3,1.3v11.6c0,0.7,0.6,1.3,1.3,1.3h28.3c0.7,0,1.3-0.6,1.3-1.3V20 C30.9,19.3,30.3,18.8,29.7,18.8z M28.4,30.4H2.6v-9.1h5.9c0.7,0,1.3-0.6,1.3-1.3V7.2h11.6v12.9c0,0.7,0.6,1.3,1.3,1.3h5.9v9H28.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.34cc68745c9b6c176fc2c1f228d7912d.svg";
export { ForwardRef as ReactComponent };